import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getDateFormat, getDateTimeInUserTimeZone } from '../utils/time';
import { getWord } from '../utils/tenant';
import MaterialIcon from '../SF/MaterialIcon';
import css from './BatchSentItemsRow.scss';

export default class BatchSentItemsRow extends React.Component {
  
  get action() {
    switch (this.props.actionType) {
      case 'ActionPlan':
        return 'Add Success Plan';
      case 'Flag':
        return 'Raise Flag';
      case 'Referral':
        return 'Create Referral';
      case 'Kudos':
        return `Create ${getWord('kudos')}`;
      case 'To-Do':
        return 'Create To-Do';
      case 'Message':
        return 'Send Message';
      case 'Note':
        return 'Create Note';
      case 'Comment':
        return 'Comment on Item';
      case 'ClearInterventionRequest':
        return `Resolve ${getWord('tracker')} Item`;
      case 'AssignInterventionRequest':
        return `Assign ${getWord('tracker')} Item`;
      default:
        return '';
    }
  }
  
  get dateSent() {
    const requestDate = getDateTimeInUserTimeZone(this.props.requestDate);
    return `${requestDate.format(getDateFormat('dateDisplayFormat'))} `
      + `at ${requestDate.format(getDateFormat('timeDisplayFormat'))}`;
  }
  
  get recipientCount() {
    if (this.props.batchedActionStatus === 'CANCELED') return 'N/A';
    return this.props.batchedActionItemsCount
  }
  
  get completionStatus() {
    switch (this.props.batchedActionStatus) {
      case 'PENDING_PROCESSING':
        return 'Pending';
      case 'IN_PROGRESS':
        return (
          <div>
            <MaterialIcon aria-hidden="true" className={css['in-progress']} icon="cached" />
            {`${this.props.completionPercentage}%`}
          </div>
        );
      case 'FAILED':
        return (
          <div>
            <MaterialIcon aria-hidden="true" className={css['error']} icon="error" />
            {`${this.props.completionPercentage}%`}
          </div>
        );
      case 'COMPLETED':
        return 'Complete';
      case 'CANCELED':
        return 'Canceled';
      default:
        return '';
    }
  }
  
  render() {
    return (
      <Table.Row>
        <Table.Cell className="action-type">{this.action}</Table.Cell>
        <Table.Cell className="date-sent">{this.dateSent}</Table.Cell>
        <Table.Cell className="recipient-count" textAlign="right">{this.recipientCount}</Table.Cell>
        <Table.Cell className="completion-status" textAlign="right">{this.completionStatus}</Table.Cell>
      </Table.Row>
    );
  }
  
}

BatchSentItemsRow.defaultProps = {
  completionPercentage: 0
};

BatchSentItemsRow.propTypes = {
  batchedActionId: PropTypes.number.isRequired,
  actionType: PropTypes.string.isRequired,
  completionPercentage: PropTypes.number,
  requestDate: PropTypes.string.isRequired,
  batchedActionItemsCount: PropTypes.number.isRequired,
  batchedActionStatus: PropTypes.string.isRequired
};
